/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setActiveSelection } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import Input from 'material/imageupload/components/input/input';



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : INPUT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
    setActiveSelection: selection => dispatch(setActiveSelection(selection)),

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Input);
